import { connect } from 'react-redux'

import { doSelectIntegration } from 'actions/userIntegrations'
import logo from 'assets/integrations/jira-server/icon-256.png'
import { selectIntegration } from 'selectors/userIntegrations'
import { emptyObj } from 'util/objects'

import withCardDataLoading from '../withCardDataLoading'
import JiraServerInAppCard from './view'

const select = state => ({
  data: emptyObj,
  image: logo,
  title: 'Jira Server',
  openStateKey: 'jira_server',
  selectedIntegration: selectIntegration(state),
})

const perform = dispatch => ({
  doOpenPane: ({ target }) => {
    dispatch(doSelectIntegration('jira_server', target))
  },
})

export default connect(select, perform)(
  withCardDataLoading(JiraServerInAppCard)
)
